module.exports = __webpack_public_path__ + "static/media/stehlik.f599a507.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/installfest/resources/presenters/stehlik.png
// module id = 466
// module chunks = 0